import Topo from './index';
import './TopoSelfAssistant.css';

// Wrapper simples que força a prop selfAssistant=true e importa CSS específico
export default function TopoSelfAssistant(props) {
  return (
    <div className="topo-self-assist" data-testid="topo-self-assist">
      <Topo {...props} selfAssistant={true} />
    </div>
  );
}
